import KidoAPIInstance from "../../services/KidoConfigApi";

export const getFileTimelineCRMApi = async () => {
	const path = `api/getFileTimelineCRM`;
	return await KidoAPIInstance.get(path);
};

export const postConfirmTimelineCRMApi = async data => {
	const path = "api/confirmTimelineCRM";
	return await KidoAPIInstance.post(path, data);
};

export const postSignatureApi = async data => {
	const path = "api/sign";
	return await KidoAPIInstance.post(path, data);
};
